<template>
    <div class="width100">



        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="10"></Aide>


        <h3 class="titreSolu text-center">Absence</h3>
        <div>
            <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
            </div>
            <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
            </div>
            <h3 class="titreSolu text-center" v-if="niveau==1">De quel type d'absence s'agit t il ? </h3>
            <h3 class="titreSolu text-center" v-if="niveau>1">{{absenceTypeNom}}</h3>
            <div class="row" v-if="niveau==1">
                <div v-for="(absenceType, keyAbsenceType) in listAbsenceType" :key="keyAbsenceType" class="colSolu col-md-12 col-lg-4">
                    <div class="thtab userList col-12 text-center rounded"
                         @click="choixNiveau1(keyAbsenceType)">
                        {{absenceType.nom}}
                    </div>
                </div>
            </div>
            <h3 class="titreSolu text-center" v-if="niveau==2">Sur quelle période ? </h3>
            <div class="row" v-if="niveau==2">
                <div class="col-12">
                    Début : <input type="date" class="form-control" v-model="absDeb" >
                </div>
                <br />
                <div class="col-12">
                    Fin : <input type="date" class="form-control"  v-model="absFin" @change="afficherValide()">
                </div>
            </div>

            <br />
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-danger" v-if="niveau>1" block @click="annuleNiveau()">Annuler</button>
                    &nbsp;
                    <button class="btn btn-primary" block @click="valideAbsence()"
                            v-if="afficheValide==1"
                    >Valider</button>
                </div>
            </div>
        </div>
        <div class="accordion" role="tablist">

                <h4  >Historique de l'année
                    <select v-model="histoAnnee"  @change="getHistoAbsence()">
                        <option></option>
                        <option v-for="(annee, key) in listAnnee" :key="key"
                                v-bind:value="annee">{{ annee }}
                        </option>
                    </select>
                </h4>
            <div class="row">
                <div class="row" v-for="(histo, key) in listHisto" :key="key" >
                    <div class="col-8">{{ afficheDateFRByString(histo.dateDebut) }} au {{ afficheDateFRByString(histo.dateFin) }}</div>
                    <div class="col-4 text-center"><i v-if="histo.valide == 0" class="fa-solid fa-trash-can btn btn-danger" @click="deleteAbsence(histo.id,afficheDateFRByString(histo.dateDebut),afficheDateFRByString(histo.dateFin))"></i></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Aide from './Aide';
    export default {
        name: "Absence",
        props: ['token', 'site', 'user', 'racine', 'listUser', 'userId', 'userType', 'idUser', 'systemeClient', 'systemeClientId'
            , 'ifAppli'],
        data() {
            return {
                aide: '', errors: [], listAbsenceType: [],absenceTypeId:null,absenceTypeNom:null,niveau:1,absDeb:null,absFin:null,
                afficheValide:0,idUserLingevres:null,msgs2:[],listHisto:[],listAnnee:[],histoAnnee:0
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            getAbsenceTypes() {
                fetch(this.racine + this.site + 'api/absence_types', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listAbsenceType = json['hydra:member']
                            console.log(this.listAbsenceType)
                        }
                    })
                })
            },
            getHistoAbsence() {
                fetch(this.racine + this.site + 'api/absences?dateDebut='+this.histoAnnee+'&user='+this.idUserLingevres, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listHisto = json['hydra:member']
                            console.log(this.listHisto)
                        }
                    })
                })
            },
            getUserLingevres() {
                fetch(this.racine + this.site + 'api/get_id_user_lingevres/' + this.idUser, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.idUserLingevres = json['idUserLingevres']
                        }
                    })
                })
            },
            choixNiveau1(keyAbsenceType)
            {
                console.log(keyAbsenceType)
                this.niveau = 2
                this.absenceTypeId = this.listAbsenceType[keyAbsenceType].id
                this.absenceTypeNom = this.listAbsenceType[keyAbsenceType].nom

            },
            annuleNiveau()
            {
                this.niveau--

            },
            afficherValide()
            {
                this.afficheValide = 0
                this.errors = []
                if(this.absDeb!=null && this.absFin!=null)
                {
                    var deb = new Date(this.absDeb);
                    var fin = new Date(this.absFin);
                    if(deb>fin)
                    {
                        this.errors.push('La période est incorrecte.');
                    }
                    else
                    {
                        this.afficheValide = 1
                    }
                }
            },
            afficheDateFRByString(date)
            {
                var date2 = new Date(date)
                return this.afficheDateFR(date2)
            },
            afficheDateFR(date)
            {
                return (date.getDate()<= 9 ? '0' + date.getDate() : date.getDate())+"/"+((date.getMonth()+1)<=9 ? '0' + (date.getMonth()+1) : (date.getMonth()+1))+"/"+date.getFullYear()
            },
            valideAbsence()
            {
                if(this.absDeb!=null && this.absFin!=null)
                {
                    this.errors = []
                    this.msgs2 = []
                    var deb = new Date(this.absDeb);
                    var fin = new Date(this.absFin);
                    if(deb>fin)
                    {
                        this.errors.push('La période est incorrecte.');
                    }
                    else
                    {
                        this.$bvModal.msgBoxConfirm("Etes vous sûr de vouloir poser du "+this.afficheDateFR(deb)+" au "+this.afficheDateFR(fin)+" en "+this.absenceTypeNom+"?", {
                            title: 'Etes vous sûr?',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {
                                    console.log(this.absDeb)
                                    console.log(this.absFin)

                                    var myHeaders = new Headers();
                                    myHeaders.append("Authorization", "Bearer "+this.token);

                                    var formdata = new FormData()
                                    formdata.append('debut', this.absDeb)
                                    formdata.append('fin', this.absFin)
                                    formdata.append('idUser', this.idUserLingevres)
                                    formdata.append('idUserMaintenance', this.idUser)
                                    formdata.append('idAbsenceType', this.absenceTypeId)

                                    var requestOptions = {
                                        method: 'POST',
                                        headers: myHeaders,
                                        body: formdata,
                                        redirect: 'follow'
                                    };

                                    fetch(this.racine + this.site + 'api/save_absence', requestOptions)
                                        .then(response => response.json())
                                        .then(json => {

                                            console.log(json);
                                            if (json['msg'] != "") {
                                                this.errors.push(json['msg'])
                                            }
                                            else if (json['valide'] > 0) {
                                                this.msgs2.push("Votre demande a bien été prise en compte.")
                                            }
                                            else {
                                                this.errors.push("Un problème inconnu s'est produit.")
                                            }
                                        })
                                }
                            })
                    }
                }

            },
            deleteAbsence(absenceId,dateDeb,dateFin)
            {
                this.errors = []
                this.msgs2 = []

                this.$bvModal.msgBoxConfirm("Etes vous sûr de vouloir supprimer votre demande du "+dateDeb+" au "+dateFin+"?", {
                    title: 'Etes vous sûr?',
                    size: 'lg',
                    buttonSize: 'lg',
                    okVariant: 'danger',
                    okTitle: 'Oui',
                    cancelTitle: 'Non',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    noFade: true
                })
                    .then(value => {
                        if (value == true) {
                            fetch(this.racine + this.site + 'api/absences/' + absenceId, {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + this.token
                                },
                            }).then(response => {
                                this.getHistoAbsence()
                                console.log(response)
                            })
                        }
                    })
            },
        },
        mounted() {
            this.getAbsenceTypes()
            this.getUserLingevres()
            var date = new Date()
            this.listAnnee[0] = date.getFullYear()-1
            this.listAnnee[1] = date.getFullYear()

        },
        components: {
            Aide,
        }
    }
</script>


<style scoped>
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border: 2px white solid;
        font-size: 28px;
    }

    .listMachineNonCharge {
        font-size: 28px;
    }
</style>
